const api = {
  designs: {
    legacyVersion: 4,
    version: 5
  }
};

export default api;
